import { Component, OnInit, ViewEncapsulation } from "@angular/core"
import { Router, NavigationStart, NavigationEnd } from "@angular/router"
import { Helpers } from "./helpers"
import { AppConfig } from "./app.config"
import { GrayLogService } from "./cadastro/admin/services/graylog/graylog.service"
import { LexTranslateService } from "./core/services/lex-translate.service"
import { PrivallyService } from "./core/services/privally.service"
import { ObservabilityService } from "./core/observability/observability.service"

declare let ga: Function
const UACode = AppConfig.UACode

@Component({
  selector: "seb-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  title = "seb-front-end"
  urlToken: any
  currentRole: string

  constructor(
    private _router: Router,
    private grayLogService: GrayLogService,
    private lextranslate: LexTranslateService,
    private observability: ObservabilityService,
    private privallyService: PrivallyService
  ) {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.observability.trackNavigation(event.urlAfterRedirects)
        ga("set", "page", event.urlAfterRedirects)
        ga("send", "pageview")
      }
    })
    this.appendGaTrackingCode()
  }

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()

    // Initialize Privally service after language is loaded
    this.privallyService.init()

    this._router.events.subscribe((route) => {
      if (route instanceof NavigationStart) {
        Helpers.setLoading(true)

        Helpers.bodyClass("fixed-navbar")
      }
      if (route instanceof NavigationEnd) {
        window.scrollTo(0, 0)
        Helpers.setLoading(false)
        Helpers.initPage()
      }
    })
  }

  private appendGaTrackingCode() {
    try {
      const script = document.createElement("script")
      script.innerHTML = `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', '${UACode}', 'auto');
      `
      document.head.appendChild(script)
    } catch (ex) {
      let full_message = "Error appending google analytics: " + ex.message

      this.grayLogService.logError(full_message)
    }
  }
}
